import React, { useEffect, useState } from 'react';
import { ISelectOption, Select } from 'ui-toolkit';
import { ClickToViewTableHeader } from './ClickToViewTableHeader';

export interface ITypeAheadMultiselectHeaderProps {
  text: string;
  values: string[];
  options: ISelectOption<string>[];
  onFilterChange: (values: string[]) => void;
}

export const TypeAheadMultiselectHeader: React.FC<ITypeAheadMultiselectHeaderProps> = ({
  text,
  values,
  options,
  onFilterChange,
}) => {
  const [selected, setSelected] = useState<ISelectOption<string>[]>(options.filter((t) => values.includes(t.value)));
  useEffect(() => {
    setSelected(options.filter((t) => values.includes(t.value)));
  }, [values, options, setSelected]);
  return (
    <ClickToViewTableHeader
      text={text}
      filterText={!!values.length && `(${values.length})`}
      filterComponent={
        <Select
          value={selected}
          onChange={(value: ISelectOption<string>[]) => setSelected(value)}
          isMulti
          options={options}
          autoFocus
          placeholder="Search"
        />
      }
      onFilterDone={() => onFilterChange(selected.map((t) => t.value))}
    />
  );
};
